import _ from "lodash";

require('../../bootstrap');

import Vue from 'vue';
import ComponentSet from "../../ComponentSet";
import utils from "../../Utils";
import Constants from "../../Constants";

import * as rules from 'vee-validate/dist/rules';
import en from 'vee-validate/dist/locale/en.json';
import {extend, localize, setInteractionMode, ValidationObserver, ValidationProvider} from 'vee-validate';

en.messages.min = "Please enter 6~12 English letters or numbers."
en.messages.confirmed = "The password does not match."

// -------------------------------------------------------
//                  VeeValidate 設定
// -------------------------------------------------------
localize('en', en);
setInteractionMode('eager');

Object.keys(rules).forEach(rule => {
    extend(rule, rules[rule]);
});

extend('password', {
    validate(value) {
        let regex = /^[a-zA-Z\d]{6,12}$/;
        return regex.test(value);
    },
    message(field, values)
    {
        return `Please enter 6~12 English letters or numbers.`
    },
});

const components = _.assign(ComponentSet, { ValidationProvider, ValidationObserver,} );

// --------------------------------------------------------------
//                          主程式
// --------------------------------------------------------------
const app = new Vue({
    components: components,
    mixins: [utils],
    data: { 
        token                  : "",
        username               : "",
        password               : "",
        confirm_password       : "",
        name                   : "",
        gender                 : "",
    },
    created() {
        // 使用 Utils 的 method 設定
        //defaultOnCreated(this);
    },
    beforeDestroy() {

    },
    mounted() {
        let self = this;
        // 取回該頁面需要用到的資料
        this.retrieveSiteContentData(function () {
            self.$nextTick(function() {
                self.loadToken(self, 'register');
            });
        });        
    },
    methods: {
        confirmData(){
            this.showMessage({ config: {
                msg: "Are you sure you want to register?",
                btns:[{ label: "Cancel" }, { label: 'OK', onClick: this.submitData }]    
            }});
        },
        submitData(){
            
            let url  = Constants.serverRoot+`/frontend/verify-token2`;

            let self = this;

            this.showLoading = true;

            _.set(this, 'contentData.post.username'              , this.username);
            _.set(this, 'contentData.post.password'              , this.password);
            _.set(this, 'contentData.post.name'                  , this.name);
            _.set(this, 'contentData.post.gender'                , this.gender);
            _.set(this, 'contentData.post.token'                 , this.token);
            _.set(this, 'contentData.post.currentUrl'         , Constants.serverRoot+`/api/register/save`);


            this.$http.post(url, _.get(self, 'contentData.post', null))
                .then(function (response){
                    let data = response.data.Value;
                    if (data.success) {
                        self.$refs.observer.reset();
                        window.location.href = data.value.url;
                    } else {
                        self.showMessage({ config: {
                            msg: data.message
                        }});
                    }
                    self.showLoading = false;
                    self.loadToken(self, 'register');
                })
                .catch(function (error) {
                    self.showMessage({ config: {
                        msg: '請稍後再試。'
                    }});
                    self.showLoading = false;
                    self.loadToken(self, 'register');
                })
        }
    }, // end of methods
    computed: {
        serverRoot() {
            return Constants.serverRoot
        }
    }, // end of computed
}).$mount('#app');